module.exports = __webpack_public_path__ + "img/EOTP_button_facebook.f799187a.svg";